import Navbar from "./components/Navbar/Navbar";
import Intro from "./components/Intro/Intro";
import Services from "./components/Services/Services";
import "./App.css";
import Experience from "./components/Experience/Experience";
import Works from "./components/Works/Works";
import Portfolio from "./components/Portfolio/Portfolio";
import Portfolio2 from "./components/Portfolio2/Portfolio2";

import Testimonial from "./components/Testimonials/Testimonial";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import Materiel from "./components/Materiel/Materiel";


function App() {
  return (
    <div
      className="App"
    >
      <Navbar />
      <Intro />
      <Services />

      <Experience />

      <Works />

      <Materiel/>
      <Portfolio />
      <Portfolio2 />

      <Testimonial />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
